import { render } from "./overview-list.vue?vue&type=template&id=419c2ab4&scoped=true"
import script from "./overview-list.vue?vue&type=script&lang=js"
export * from "./overview-list.vue?vue&type=script&lang=js"

import "./overview-list.vue?vue&type=style&index=0&id=419c2ab4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419c2ab4"]])

export default __exports__